import BaseClass from "../BaseClass";
import Sort from "./Sort";

const defaultOptions = {};

/**
 * This class is used for handling sorts.
 */
export default class SortsWrapper extends BaseClass {

  constructor(options) {
    super(options, defaultOptions);

    this.init();
  }

  init() {
    $(document).ready(() => {
      $('[data-sort]').each((index, element) => {
        let sort = new Sort($(element).data('sort'));
      });
    });
  }
}
